/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.mailupSubscribe = function(form, email, fields) {
  const self = this;
  const ADMIN_CONSOLE_URL = 'http://c8e7a.emailsp.com/';
  const listID = '1';
  let groupID = '494';
  const market = window.market.handle;
  if (market == 'it') {
    groupID = '493';
  }
  if (fields) {
    // New newsletter popup
    if (fields.clothing) groupID += ',568'; // New In
    if (fields.cafe) groupID += ',569';
    if (fields.events) groupID += ',570'; // Programma Culturale
  }

  let params = 'source=' + Shopify.shop + '&list=' + listID + '&group=' + groupID + '&email=' + email + '&confirm=false';
  if (fields) {
    if (fields.campo29) {
      params += '&csvFldNames=campo1;campo2;campo29';
      params += '&csvFldValues=' + fields.campo1 + ';' + fields.campo2 + ';' + fields.campo29;
    } else {
      // New newsletter popup
      params += '&csvFldNames=campo1;campo2;campo4;campo8';
      params += '&csvFldValues=' + fields.campo1 + ';' + fields.campo2 + ';' + fields.campo4 + ';' + fields.campo8;
    }
  }

  console.log(`${ADMIN_CONSOLE_URL}frontend/xmlSubscribe.aspx?${params}`);
  fetch(`${ADMIN_CONSOLE_URL}frontend/xmlSubscribe.aspx?${params}`, {method: 'POST'}).then((res) => res.text()).then((result) => {
    if (form) {
      const event = new CustomEvent("mailup-form-submit", {
        detail: {
          'form': form,
          'is_custom': form.classList.contains('g-container')
        }
      });
      window.dispatchEvent(event);
      setCookie("newsletter_cookie", true);
    }
  }).catch((error) => console.log(error));
}

Shopify.mailupShowMessage = function(form, result) {
  let message = document.createElement('p')
  message.className = "form__message pt-[16px] tinyBig regular left leading-[20px]";
  message.innerText = result;

  switch (result) {
    case "0":

      // Display a message saying the user was subscribed successfully
      console.log('Subscription completed')
      message.className = "form__message pt-[16px] tinyBig regular left leading-[20px]";
      message.innerText = 'Thanks for subscribing';

      break;
    case "1":

      // Display a message saying the service is not accessible at the moment
      console.log('Service is not accessible at the moment')

      message.className = "form__message pt-[16px] tinyBig regular left leading-[20px]";
      message.innerText = 'Thanks for subscribing';
      break;
    case "2":

      // Display a message saying the email address in an invalid address
      console.log('Invalid address')

      message.className = "form__message pt-[16px] tinyBig regular left leading-[20px]";
      message.innerText = 'Thanks for subscribing';
      break;
    case "3":

      // Display a message saying that the user is already subscribed
      console.log('User already subscribed')

      message.className = "form__message pt-[16px] tinyBig regular left leading-[20px]";
      message.innerText = 'Thanks for subscribing';
      break;
    case "-1011":

      // Display a message saying that the user is already subscribed
      console.log('IP not registered')

      message.className = "form__message pt-[16px] tinyBig regular left leading-[20px]";
      message.innerText = 'Thanks for subscribing';
      break;
    default:

      // Display a message saying the service is temporarily unavailable
      // console.log('Generic error')
      break;
  }

  if (form && form.querySelector('.form__message')) {
    form.querySelector('.form__message').remove()
  }
  form.appendChild(message)
}

class MailupForm extends HTMLElement {
  constructor() {
    super();

    this.type = null;
    this.form = this.querySelector('form');
    this.email = this.form
      ? this.form.querySelector('input[type="email"]')
      : ''
    this.name = this.form
      ? this.form.querySelector('input[name="contact[name]"]')
      : ''
    this.lastname = this.form
      ? this.form.querySelector('input[name="contact[lastname]"]')
      : ''
    this.country = this.form
      ? this.form.querySelector('select[name="contact[country]"]')
      : ''
    this.city = this.form
      ? this.form.querySelector('input[name="contact[city]"]')
      : ''
    this.eventsCheckbox = this.form
      ? this.form.querySelector('#events-checkbox')
      : ''
    this.clothingCheckbox = this.form
      ? this.form.querySelector('#clothing-checkbox')
      : ''
    this.cafeCheckbox = this.form
      ? this.form.querySelector('#cafe-checkbox')
      : ''
    this.message = this.form
      ? this.form.querySelector('textarea')
      : ''

    this.bindEvents();
  }

  bindEvents() {
    const self = this;
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()
      e.stopImmediatePropagation()

      let formToSubmit = this.form

      let acceptMarketing = this.form && this.form.querySelector('input[name="contact[newsletter]"]')
        ? this.form.querySelector('input[name="contact[newsletter]"]').checked
        : true

      if (this.hasAttribute('data-custom-form')) {
        formToSubmit = document.querySelector('.g-container')
        this.setCustomFormData(formToSubmit)
      }

      if (acceptMarketing) {
        Shopify.mailupSubscribe(formToSubmit, this.email.value, {
          'campo1': this.name.value,
          'campo2': this.lastname.value,
          'campo4': this.city.value,
          'campo8': this.country.value,
          'events': this.eventsCheckbox.checked,
          'clothing': this.clothingCheckbox.checked,
          'cafe': this.cafeCheckbox.checked
        });
      } else {
        this.submitForm(formToSubmit, this.hasAttribute('data-custom-form'))
      }
    })

    this.addEventListener("click", (e)=>{
      this.type = this.dataset.type;
    })

    window.addEventListener('mailup-form-submit', (e) => {
      self.submitForm(e.detail.form, e.detail.is_custom);
      if(self.type != null){
        window.dataLayer.push({ 
          'event': 'gaEvent',
          'category': 'contact',
          'action': 'newsletter',
          'label': self.type
        })
      }
      
    })
  }

  submitForm(form, isCustom = false) {
    const self = this
    if (isCustom) {
      form.querySelector('button').click()
      if (document.querySelector('#snack_bar_event')) {
        document
          .querySelector('#snack_bar_event .snippet-snackbar')
          .classList
          .add('mostra')
          document
          .querySelector('#snack_bar_event')
          .classList
          .remove('hidden');
        document.querySelector('.primo-layer').classList.remove('hidden');
        document.querySelector('.secondo-layer').classList.add('hidden');
        self.form.reset()
        setTimeout(() => {
          document.querySelector('#snack_bar_event .snippet-snackbar').classList.remove('mostra');
        }, 5000);
      }
    } else {
      if (document.querySelector('#snack_bar_event')) {
        document
          .querySelector('#snack_bar_event .snippet-snackbar')
          .classList
          .add('mostra')
          document
          .querySelector('#snack_bar_event')
          .classList
          .remove('hidden');
        document.querySelector('.primo-layer').classList.remove('hidden');
        document.querySelector('.secondo-layer').classList.add('hidden');
        form.submit()
      } else {
        form.submit()
      }
    }
  }

  setCustomFormData(customForm) {
    const customEmail = customForm.querySelector('[data-type="email"]')
    const customMessage = customForm.querySelector('[data-type="textarea"]')
    const customPrivacy = customForm.querySelector('[data-type="acceptTerms"]')
    const customNewsletter = customForm.querySelector('[data-type="checkbox"]')

    customEmail.value = this.email.value
    customMessage.value = this.message.value
    customPrivacy.checked = this.form.querySelector('#privacy-policy-checkbox')
      ? this.form.querySelector('#privacy-policy-checkbox').checked
      : true
    customNewsletter.checked = this.form.querySelector('input[name="contact[newsletter]"]')
      ? this.form.querySelector('input[name="contact[newsletter]"]').checked
      : false

  }

}
customElements.define('mailup-form', MailupForm);